module.exports = __webpack_public_path__ + "static/media/svg-logo.2af47d46.svg";